module.exports = __webpack_public_path__ + "static/media/step-1-of-2.f21981a4.png";